export default __webpack_public_path__ + "static/media/Snd_LowerFCross.35e078d9.mp3";